import { QueryClient, QueryClientProvider } from "react-query";

import { AppRouter } from "./AppRouter";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { ReactFlowProvider } from "@xyflow/react";

const queryClient = new QueryClient();

export const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <DndProvider backend={HTML5Backend}>
        <ReactFlowProvider>
          <AppRouter />
        </ReactFlowProvider>
      </DndProvider>
    </QueryClientProvider>
  );
};
